import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import styles from './FormStyles.module.scss';

const BackButton = ({ onClick, className }) => {
    return (
        <button
            type="button"
            className={`${styles.backButton} ${className || ''}`}
            onClick={onClick}
            aria-label="Back"
        >
            <FontAwesomeIcon icon={faArrowLeft} />
        </button>
    );
};

export default BackButton;
